import * as Sentry from '@sentry/nextjs';

class SentryClient {
  static captureError(error: Error): void {
    if (process.env.NODE_ENV !== 'production') {
      // we want to allow console.error on error handling
      // eslint-disable-next-line no-console
      console.error(error);
    }
    Sentry.captureException(error);
  }
}

export default SentryClient;
